import { TwoFactor } from "@/modules/auth/components";
import { AppPaths, Challenge } from "@/shared/common/enums";
import { useAppSelector } from "@/shared/hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const TwoFactorPage = () => {
  const challenge = useAppSelector((state) => state.auth.challenge);
  const navigate = useNavigate();

  useEffect(() => {
    if (challenge !== Challenge.TwoFactorAuthentication) {
      navigate(AppPaths.Login);
    }
  }, []);

  return <TwoFactor />;
};
